'use client'
import { Button } from "@repo/web-ui/components/base/button";
import { ClickableCard, ClickableCardDescription, ClickableCardHeader, ClickableCardTitle } from "@repo/web-ui/components/base/clickable-card";
import { BookOpen, Cone, GraduationCap, Hand, PersonStanding, Rocket, Settings2 } from 'lucide-react'
import { useRouter } from "next/navigation";

// TODO(Remove comments when functionality is added)
const cards = [
  // {
  //   title: 'Getting started',
  //   icon: <Rocket />,
  //   description: 'Get to know the Pitch Designer App.',
  //   href: '/getting-started',
  // },
  
  {
    title: 'My pitches',
    icon: <PersonStanding />,
    description: 'Build and customize your pitches.',
    href: '/pitches',
  },
  {
    title: 'Visualizer',
    icon: <Cone className="rotate-90" />,
    description: 'Tools to evaluate your arsenal of pitches.',
    href: '/visualizer',
  },
  // {
  //   title: 'Settings',
  //   icon: <Settings2 />,
  //   description: 'Change pitcher and app settings.',
  //   href: '/settings',
  // },
  {
    title: 'Common Grips',
    icon: <Hand />,
    description: 'Basic pitch grips to get started',
    href: '/common-grips',
  },
  {
    title: 'Training guides',
    icon: <BookOpen />,
    description: 'Guides to improving your on-field performance.',
    href: '/training-guides',
  },
  // {
  //   title: 'Learning pitch metrics',
  //   icon: <GraduationCap />,
  //   description: 'Resources to help you understand pitch terminology.',
  //   href: '/learn',
  // },
]
 
export default function Page() {
  const router = useRouter()

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      <p className="text-3xl text-center font-header">Welcome to the Ravik Pitch Designer App!</p>
      {/* TODO(Update link to amazon page) */}
      <a href='https://www.amazon.com/stores/RavikSports/page/AC350CB5-FE57-4AB4-981C-44BC4C0934BB?is_byline_deeplink=true&deeplink=AC350CB5-FE57-4AB4-981C-44BC4C0934BB&redirect_store_id=AC350CB5-FE57-4AB4-981C-44BC4C0934BB&lp_asin=B0FN9KBDPG&ref_=cm_sw_r_ud_ast_store_1SBA212YFSS4E41A39CK' target="_blank">
        <Button size={'lg'}>Get Ravik Spin Command Balls</Button>
      </a>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-xl">
        {cards.map(card => (
          <ClickableCard key={card.title} onClick={() => router.push(card.href)}>
          <ClickableCardHeader>
            <ClickableCardTitle className="flex gap-2 items-center">{card.icon} {card.title}</ClickableCardTitle>
            <ClickableCardDescription className="text-sm">{card.description}</ClickableCardDescription>
          </ClickableCardHeader>
        </ClickableCard>
        ))}

        
        
        

      </div>
    </div>
  )
}